const toneForKind = {
  status: 'bad',
  redirect: 'bad',
  body: 'warn',
  header: 'muted',
  network: 'warn',
  isp: 'bad',
  timing: 'warn',
};

export default function SignalList({ signals }) {
  if (!signals || signals.length === 0) {
    return <p className="signals__empty">No geo-blocking signals detected.</p>;
  }

  return (
    <div className="signals">
      {signals.map((signal, index) => (
        <div className="signal" key={`${signal.label}-${index}`}>
          <span className={`dot dot--${toneForKind[signal.kind] ?? 'muted'}`} />
          <span>{signal.label}</span>
          <span className="signal__weight">+{signal.weight}</span>
        </div>
      ))}
    </div>
  );
}
